import { memberState, pricesState, subscriptionState } from "../../../state/atoms";
import { useRecoilState } from "recoil";
import AccountsApi from "../../../api/AccountsApi";
import { MemberDtoPlanEnum, SubStatusDtoAddonsCycleEnum } from "../../../generated/dashboard-client";
import { useEffect, useState } from "react";

interface Props {
  add?: boolean;
}

export default function LocationPriceText({ add }: Props) {
  const [member] = useRecoilState(memberState);
  const [prices, setPrices] = useRecoilState(pricesState);
  const [subscription, setSubscription] = useRecoilState(subscriptionState);
  const [priceLoaded, setPriceLoaded] = useState(false);
  const [locationPrice, setLocationPrice] = useState(0);
  const [monthlyPrice, setMonthlyPrice] = useState(0);
  const [annuallyPrice, setAnnuallyPrice] = useState(0);
  const [annual, setAnnual] = useState(false);

  useEffect(() => {
    if (!member.id) return;
    AccountsApi.getAvailablePrices(member.id).then(resp => setPrices(resp.data));
  }, [member.id, setPrices]);

  useEffect(() => {
    if (!prices || !prices.length) return;
    setMonthlyPrice(prices.find(it => it.type === "MONTHLY")?.total || 0);
    setAnnuallyPrice((prices.find(it => it.type === "ANNUALLY")?.total || 0) / 12);
  }, [prices]);

  useEffect(() => {
    if (!member.id) return;
    if (member.plan === MemberDtoPlanEnum.Free) {
      setAnnual(true);
      setLocationPrice(annuallyPrice);
      setPriceLoaded(true);
    } else {
      if (subscription.addonsCycle === SubStatusDtoAddonsCycleEnum.Monthly) {
        setLocationPrice(monthlyPrice);
        setAnnual(false);
      } else {
        setAnnual(true);
        setLocationPrice(annuallyPrice);
      }
      setPriceLoaded(true);
    }
  }, [member.id, member.plan, annuallyPrice, monthlyPrice, subscription]);

  useEffect(() => {
    AccountsApi.getSubscription(member.id)
      .then((resp) => {
        setSubscription(resp.data);
      });
  }, [member.id, setSubscription]);

  return <>
    {priceLoaded && !!locationPrice && <>
      {member.diningRDIntegrationDesign && <>
        {!add && <p>Manage all your locations from a single account. Your subscription is managed by DiningRD.</p>}
        {add && <>Manage all your locations from a single account.<br/>Your subscription is managed by DiningRD.</>}
      </>}
      {!member.diningRDIntegrationDesign && <>
        {!add && <p>
          Manage all your storefronts and brands from a single account. ${locationPrice}/mo per location{annual ? ", based on annual contract" : ""}.
        </p>}

        {add && <>Add a Location for ${locationPrice}/mo each{annual ? ", based on annual contract" : ""}</>}
      </>}
    </>}
  </>;
}
